var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn",style:({ backgroundImage: `url(${_vm.bg})`})},[_c('div',{staticClass:"button",on:{"click":_vm.gotoWeb}},[_c('img',{attrs:{"src":_vm.downloadBtn,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }